<template>
  <v-app>
    <v-container fluid>
      <v-row>
        <v-col cols="12">

          <v-expansion-panels v-model="panel1">
            <v-expansion-panel>
              <v-expansion-panel-title
                color="blue-grey-lighten-4"
                class="panel-header"
              >
                Search  Form
              </v-expansion-panel-title>

              <v-expansion-panel-text>
                <v-form @submit.prevent="submit">
                  <v-row class="py-2 px-2">
                    <v-col lg="4" md="4" cols="12" > 
                        <v-autocomplete
                          v-model="year.value.value"
                          :error-messages="year.errorMessage.value"
                          :items="getYearList"
                          item-title="label"
                          item-value="value"
                          variant="outlined"
                          label="Enter Year"
                          density="compact"
                          bg-color="grey-lighten-4"
                          prepend-icon=""
                          prepend-inner-icon="mdi-calendar-month"
                          clearable
                        ></v-autocomplete>
                    </v-col>
                    <v-col lg="2" md="2" cols="12">
                        <v-btn
                          class="bg-brand w-15"
                          type="submit"
                          ref="searchButton"
                          >Search</v-btn
                        >
                    </v-col>
                  </v-row>
                </v-form>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>

          <v-expansion-panels v-model="panel">
            <v-expansion-panel>
              <v-expansion-panel-title
                color="blue-grey-lighten-4"
                class="panel-header"
              >
                My Leave List
              </v-expansion-panel-title>

              <v-expansion-panel-text>
                <v-row class="py-2">
                  <v-col md="4" cols="12">
                    <v-text-field
                      v-model="search"
                      append-inner-icon="mdi-magnify"
                      label="Search"
                      single-line
                      hide-details
                      density="compact"
                      variant="outlined"
                      bg-color="grey-lighten-4"
                      class="pl-2"
                      clearable
                    ></v-text-field>
                  </v-col>

                  <v-col md="5" cols="12">
                    <div class="d-flex align-center flex-column">
                      <v-btn-group
                        variant="outlined"
                        density="compact"
                        size="x-small"
                        divided
                      >
                        <v-btn
                          prepend-icon="mdi mdi-download"
                          variant="flat"
                          color="success"
                          @click="exportToCSV"
                        >
                          CSV
                        </v-btn>
                        <v-btn
                          prepend-icon="mdi mdi-download"
                          variant="flat"
                          color="primary"
                          @click="exportToExcel"
                        >
                          EXCEL
                        </v-btn>
                        <v-btn
                          prepend-icon="mdi mdi-download"
                          variant="flat"
                          color="red"
                          @click="exportToPDF"
                        >
                          PDF
                        </v-btn>
                      </v-btn-group>
                    </div>
                  </v-col>
                </v-row>

                <v-data-table
                  :headers="headers"
                  :items="getSchema"
                  :loading="loading"
                  v-model:items-per-page="itemsPerPage"
                  :search="search"
                  :custom-filter="customSearch"
                  density="compact"
                  class="elevation-1"
                >
                  <template v-slot:item.index="{ index }">
                    {{ ++index }}
                  </template>

                  <template v-slot:item.employee="{ item }">
                    {{ item.employee?.name }}
                  </template>

                  <template v-slot:item.leave_type="{ item }">
                    {{ item.leave_type?.name }}
                  </template>

                  <template v-slot:item.start_date="{ item }">
                    {{ formatDateView(item.start_date) }}
                  </template>
                  <template v-slot:item.end_date="{ item }">
                    {{ formatDateView(item.end_date) }}
                  </template>

                  <!-- <template v-slot:item.start_day_status="{ item }">
                    {{ item.start_day_status == 'first_half' ? 'First Half' : 'Second Half' }}
                  </template>

                  <template v-slot:item.end_day_status="{ item }">
                    {{ item.end_day_status == 'first_half' ? 'First Half' : 'Second Half' }}
                  </template> -->

                  <template v-slot:item.approval_status="{ item }">
                    <v-chip
                      v-if="approvalProcess(item)?.status === 'Pending'"
                      color="yellow-darken-3"
                      size="small"
                    >
                      <!-- Waiting for {{ approvalProcess(item)?.approval_step_name?.name }} -->
                       Applied
                    </v-chip>

                    <v-chip
                      v-else-if="approvalProcess(item)?.status === 'Forwarded'"
                      color="green"
                      size="small"
                    >
                      Forwarded By {{ approvalProcess(item)?.approval_step_name?.name }}
                    </v-chip>

                    <v-chip
                      v-else-if="approvalProcess(item)?.status === 'Approved'"
                      color="green"
                      size="small"
                    >
                      Approved By {{ approvalProcess(item)?.approval_step_name?.name }}
                    </v-chip>

                    <v-chip
                      v-else-if="approvalProcess(item)?.status === 'Cancelled'"
                      color="red"
                      size="small"
                    >
                      Cancelled By {{ approvalProcess(item)?.approval_step_name?.name }}
                    </v-chip>

                    <v-chip
                      v-else
                      color="green"
                      size="small"
                    >
                      {{ item.approval_status == 'Pending' ? 'Applied' : item.approval_status }}
                    </v-chip>

                  </template>

                  <template v-slot:item.status="{ item }">
                    <v-chip
                      v-if="item.status == 1"
                      color="success"
                      size="small"
                      class="text-capitalize"
                      >Active</v-chip
                    >
                    <v-chip
                      v-else
                      color="red"
                      size="small"
                      class="text-capitalize"
                      >Inactive</v-chip
                    >
                  </template>

                  <template v-slot:item.actions="{ item }">
                    <v-icon
                      color="primary"
                      class="me-2"
                      @click="editItem(item)"
                      v-if="canEdit(item)"
                      title="Edit"
                    >
                      mdi-pencil-outline
                    </v-icon>
                    <v-icon
                      color="info"
                      class="me-2"
                      @click="viewItem(item)"
                      title="View"
                    >
                      mdi-eye-outline
                    </v-icon>
                  </template>
                </v-data-table>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>

        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
import { useStore } from "vuex";
import { useField, useForm } from "vee-validate";
import * as yup from "yup";
import { ref,onMounted } from "vue";
import { toast } from "vue3-toastify";
import formattedDate from "@/plugins/dateFormatter";
import { useRouter } from "vue-router";
import statusMap from "@/utils/statusMap";
import { formatDateView } from "@/plugins/helpers";
export default {
  data: () => ({
    itemsPerPage: 10,
    panel: [0],
    panel1: [0],
    loading: false,
    search: "",
    dialog: false,
    data: {},
    headers: [
      { title: "#SL", key: "index", align: "center", width: "7%" },
      { title: "Code", key: "code", align: "left" },
      { title: "Employee Name", key: "employee", align: "left" },
      { title: "Leave Type", key: "leave_type", align: "left" },
      { title: "Start Date", key: "start_date", align: "center" },
      { title: "End Date", key: "end_date", align: "center" },
      { title: "Leave Count (Days)", key: "leave_count", align: "center" },
      /* { title: "Start Day", key: "start_day_status", align: "center" },
      { title: "End Day", key: "end_day_status", align: "center" }, */
      { title: "Reason", key: "reason", align: "left" },
      { title: "Approval Status", key: "approval_status", align: "center" },
      { title: "Status", key: "status", align: "center" },
      { title: "Actions", key: "actions", align: "center" },
    ],
  }),

  setup() {

    const year = useField("year");
    const loading = ref(false);
    const store = useStore();

    const submit = (values) => {
      loading.value = true;
      const payload = {
        type: 'my',
        year: year.value.value,
      };

      store
        .dispatch("getMyLeaveList", payload)
        .then((response) => {
          loading.value = false;
          toast.success(response.data.message, {
            timeout: 2000,
          });

        })
        .catch((error) => {
          toast.error(
            error.response?.data?.message || "Failed to save voucher"
          );
        })
        .finally(() => {
          loading.value = false;
        });
    };

    onMounted(() => {
      year.value.value = new Date().getFullYear();
      submit();
    })

    return {
      submit,
      year,
    };
  },

  created() {
    
  },

  computed: {
    getSchema() {
      return this.$store.getters.getMyLeaveList;
    },
    getYearList() {
      const currentYear = new Date().getFullYear();
      const years = [];
      for (let i = currentYear - 5; i <= currentYear + 5; i++) {
          years.push(i);
      }
      return years;
    },
  },

  methods: {

    approvalProcess(item) {
      if (item.previous_approval_process) {
        return item.previous_approval_process
      }
      return item.approval_current_process
    },

    formatDateView,
    customSearch(value, search, item) {
      if (!search) return true;
      const s = search.toLowerCase();

      return (
        item.raw.code?.toLowerCase().includes(s) ||
        item.raw.employee?.name?.toLowerCase().includes(s) ||
        item.raw.leave_type?.name?.toLowerCase().includes(s) ||
        item.raw.reason?.toLowerCase().includes(s) ||
        item.raw.approval_status?.toLowerCase().includes(s)
      );
    },
    viewItem(item) {
      this.$router.push({
        name: "view-leave",
        params: { id: item.id },
      });
    },
    editItem(item) {
      this.$store.commit('editingLeaveApplication', item);
      this.$router.push({
        name: "add-application",
        query: { id: item.id },
      });
    },
   canEdit(item){
      return ((!item.approval_status || item.approval_status.toLowerCase() == 'pending' || item.status == 0) && !item.previous_approval_process)
    },
    exportToPDF() {
      const columns = [
        "#SL",
        "Code",
        "Employee",
        "Leave Type",
        "Start Date",
        "End Date",
        "Reason",
        "Status",
      ];
      let sl = 1;
      const rows = this.getSchema.map((i) => [
        sl++,
        i.code,
        i.employee?.name,
        i.leave_type?.name,
        i.start_date,
        i.end_date,
        i.reason,
        i.approval_status,
      ]);
      this.$exportTableToPDF(columns, rows, "Leave List", "leave_list_" + this.$fileDate());
    },
    exportToExcel() {
      const data = [
        [
          "#SL",
          "Code",
          "Employee",
          "Leave Type",
          "Start Date",
          "End Date",
          "Reason",
          "Status",
        ],
      ];
      let sl = 1;
      this.getSchema.forEach((i) => {
        data.push([
          sl++,
          i.code,
          i.employee?.name,
          i.leave_type?.name,
          i.start_date,
          i.end_date,
          i.reason,
          i.approval_status,
        ]);
      });
      this.$exportTableToExcel(data, "leave_list_" + this.$fileDate());
    },
    exportToCSV() {
      const data = [
        [
          "#SL",
          "Code",
          "Employee",
          "Leave Type",
          "Start Date",
          "End Date",
          "Reason",
          "Status",
        ],
      ];
      let sl = 1;
      this.getSchema.forEach((i) => {
        data.push([
          sl++,
          i.code,
          i.employee?.name,
          i.leave_type?.name,
          i.start_date,
          i.end_date,
          i.reason,
          i.approval_status,
        ]);
      });
      this.$exportTableToCSV(data, "leave_list_" + this.$fileDate());
    },
  },
};
</script>
